(() => {
  const sizeHashes = new Set(['#cista-size-reference', '#cista-size-guide']);

  const openSizeGuide = (behavior = 'auto') => {
    const guide = document.querySelector('#MainContent #cista-size-reference');
    const details = guide?.querySelector('details');
    if (!details || guide.closest('[hidden], dialog, quick-add-modal')) return false;

    details.open = true;
    const summary = details.querySelector('summary');
    summary?.setAttribute('aria-expanded', 'true');
    summary?.focus({ preventScroll: true });
    guide.scrollIntoView({ behavior, block: 'start' });
    return true;
  };

  const openFromHash = () => {
    if (sizeHashes.has(window.location.hash)) openSizeGuide();
  };

  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
      link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

    const current = new URL(window.location.href);
    const destination = new URL(link.href, current);
    if (!sizeHashes.has(destination.hash) || destination.origin !== current.origin || destination.pathname !== current.pathname ||
      (destination.search && destination.search !== current.search)) return;

    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    if (!openSizeGuide(behavior)) return;

    event.preventDefault();
    if (current.hash !== '#cista-size-reference') {
      current.hash = 'cista-size-reference';
      window.history.pushState(window.history.state, '', current);
    }
  });

  window.addEventListener('hashchange', openFromHash);
  document.addEventListener('shopify:section:load', openFromHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromHash, { once: true });
  else openFromHash();
})();
